import { projectTypes, projectTypesInversed, ProjectTypesInversedKeys, ProjectTypesKeys } from '@teinor/erp/types/company/customer/customerProject'
import { useCallback, useMemo } from 'react'
import { ItemCustomSelectDropDownRowSection } from '../../../forms/CustomSelect/CustomSelectSections/types'
import { TwinDictionary, dictionaryComplexFromJsonArr } from '../../globals/dictionary'
import { CustomerProjectTypePayload } from '../../reducers/customers/customerProjectTypes'
import useTwinTranslation from '../useTwinTranslation'

const useProjectsAndOpportunitiesDict = () => {
    const {t} = useTwinTranslation()
    const oppTranslation = t('opportunities', 'Oportunidades')
    const projectTranslation = t('projects', 'Proyectos')
    const parseSearchProjectsToSections = useCallback((projects: TwinDictionary, orderByOpp?: true) => {
        const sectionProjectsItems: ItemCustomSelectDropDownRowSection[] = []
        const sectionOppItems: ItemCustomSelectDropDownRowSection[] = []
        const indexProjects: TwinDictionary = {}
        if (projects) {
            for (const element in projects) {
                const project = projects[element]
                if (project.projectType === projectTypesInversed['project']) {
                    sectionProjectsItems.push({ ...project, value: project.id, text: project.name, hiddenText: project.name })
                } else {
                    sectionOppItems.push({ ...project, value: project.id, text: project.name, hiddenText: project.name })
                }
                indexProjects[project?.id] = { ...project, value: project.id, text: project.name, hiddenText: project.name }
            }
        }
        const projectsSection = [{ value: "", text: projectTranslation, isSection: true }, ...sectionProjectsItems]
        const oppSection = [{ value: "", text: oppTranslation, isSection: true }, ...sectionOppItems]
        const projectsSectionItems: ItemCustomSelectDropDownRowSection[] = orderByOpp ? [...oppSection, ...projectsSection] : [...projectsSection, ...oppSection]
        const projectsSectionsByName: TwinDictionary[] = [
            {
                name: projectTranslation,
                childs: dictionaryComplexFromJsonArr(sectionProjectsItems)
            },
            {
                name: oppTranslation,
                childs: dictionaryComplexFromJsonArr(sectionOppItems)
            },
        ]
        return { projectsSectionItems, projectsSectionsByName, indexProjects }
    }, [oppTranslation, projectTranslation])
    return { parseSearchProjectsToSections }
}
interface UseParseCustomerProjectTypeByStatusProps {
    customerProjectTypes: CustomerProjectTypePayload,
    projectTypeStatus: ProjectTypesInversedKeys
}
export const useParseCustomerProjectTypeByStatusSimple = () => {
    const parsedCustomerProjectTypes = useCallback((customerProjectTypes: CustomerProjectTypePayload, projectTypeStatus: ProjectTypesKeys) => {
        const result: TwinDictionary = {}
        for (const key in customerProjectTypes) {
            const element: any = customerProjectTypes[key as any];
            const customerProjectStatuses = element?.CustomerProjectStatusesByType?.[projectTypes[projectTypeStatus]]
            if (customerProjectStatuses && customerProjectStatuses.length) {
                result[key] = element
            }
        }
        return result
    }, [])
    return { parsedCustomerProjectTypes }
}

interface UseParseCustomerProjectTypeByStatusProps {
    customerProjectTypes: CustomerProjectTypePayload,
    projectTypeStatus: ProjectTypesInversedKeys
}
export const useParseCustomerProjectTypeByStatus = ({ customerProjectTypes, projectTypeStatus }: UseParseCustomerProjectTypeByStatusProps) => {
    const { parsedCustomerProjectTypes } = useParseCustomerProjectTypeByStatusSimple()
    
    const myParsedCustomerProjectTypes = useMemo(() => parsedCustomerProjectTypes(customerProjectTypes, projectTypesInversed[projectTypeStatus] as ProjectTypesKeys), [customerProjectTypes, projectTypeStatus, parsedCustomerProjectTypes])

    return { myParsedCustomerProjectTypes }
}

export const useGetCustomerProjectTypeByIsMain = () => {
    const getCustomerProjectTypeByIsMain = useCallback((customerProjectTypes: CustomerProjectTypePayload, projectType: ProjectTypesKeys) => {
        let isMainCustomerProject: TwinDictionary = {}
        const isMainByProjectTypeProp = 'is_' + projectTypes[projectType] + '_main'
        for (const key in customerProjectTypes) {
            const element: any = customerProjectTypes[key as any];
            if (element[isMainByProjectTypeProp]) {
                isMainCustomerProject = element
            }
        }
        return isMainCustomerProject
    }, [])

    return { getCustomerProjectTypeByIsMain }
}

export default useProjectsAndOpportunitiesDict